export const HOMEOWNERS_INSURANCE_FREQUENCY_TOOLTIP =
  "Homeowner's Insurance is always due annually.";

export const HOMEOWNERS_INSURANCE_AMOUNT_DUE_TOOLTIP =
  "For Homeowner's Insurance, Amount Due 1 always equals the Annual Amount.";
